import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from './store/store'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css';

import axios from 'axios';
import crypto from 'crypto';
import lrz from 'lrz';

import Viser from 'viser-vue'

import draggable from 'vuedraggable'


import menuBar from './components/components/menu_bar.vue';
import topBar from './components/components/top_bar';
import bottomBar from './components/components/bottom_bar';

router.afterEach((to, from, next) => {
	window.scrollTo(0, 0);
});

router.beforeEach((to, from, next) => {
	var logined = sessionStorage.getItem('userinfo');
	if (logined) {
		axios.defaults.headers.common['Authorization'] = JSON.stringify({
			id: JSON.parse(logined).id
		});
	}
	if (to.name == "login") {
		if (logined) {
			router.replace({
				path: "mainpage"
			});
		} else {
			next();
		}
	} else if (to.name == "forgotpassword") {
		next();
	} else if (to.name == "twiceconfirm") {
		next();
	} else if (to.name == "repassword") {
		next();
	} else if (to.name == "test") {
		next();
	} else {
		if (!logined) {
			router.replace({
				path: "login"
			});
		} else {
			next();
		}
	}
})

axios.interceptors.response.use((response) => {
	return response;
}, function(error) {
	if (403 === error.response.status) {
		if (error.response.data == "not_sufficient_funds") {
			router.push({
				name: "accountpandect"
			});
		}
		if (error.response.data == "抱歉，您无权访问该页面或执行该操作") {
			router.push({
				name: "error403"
			});
		}

	} else if (404 === error.response.status) {
		router.push({
			name: "error404"
		});
	} else if (500 === error.response.status) {
		router.push({
			name: "error500"
		});
	} else {
		return Promise.reject(error);
	}
});



Vue.config.debug = true
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(Antd);
Vue.use(Viser);

Vue.component("menuBar",menuBar);
Vue.component("topBar",topBar);
Vue.component("bottomBar",bottomBar);


new Vue({
	el: '#app',
	router: router,
	store: store,
	template: '<App/>',
	components: {
		App
	}
})



// WEBPACK FOOTER //
// ./src/client/index.js